/**
 * Defines a collection of Training Plans.  This collection is used to pull Training Plans for a user
 */
import Backbone from 'backbone';

import TrainingPlan from 'models/training_plan/TrainingPlan';

export default Backbone.Collection.extend({
    model: TrainingPlan,

    url: function() {
        return '/trainingplan-service/trainingplan/plans?limit=50'; // CA-139803 - stop gap solution for users with a lot of training plans
    },
    backend: 'gcapi',

    /**
     * The json returned is non-standard so we tweak it here so it can be successfully turned into
     * models.
     *
     * @param resp the response.
     * @param xhr the request.
     */
    parse: function(resp, xhr) {
        return resp.trainingPlanList;
    }
});
